import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_SAVE_FILTER_QUERY_KEY } from "../types/CommonTypes";
import { queryClient } from "../../../utils/ReactQueryConfig";

type UpdateFilterPayload = {
  filterId: string;
  filterName?: string;
  [key: string]: any;
};

async function updateSavedFilter(
  tenantId: string,
  hospitalId: string,
  filterId: string,
  dataToUpdate: any
): Promise<any> {
  const { data } = await fetcher({
    url: `/hospital/custom-filters/${filterId}`,
    method: "PUT",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
    data: dataToUpdate,
  });

  return data;
}

export default function useUpdateSavedFilterMutation(
  tenantId?: string,
  hospitalId?: string
) {
  return useMutation({
    mutationFn: ({ filterId, ...rest }: UpdateFilterPayload) =>
      updateSavedFilter(tenantId!, hospitalId!, filterId, rest),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_SAVE_FILTER_QUERY_KEY, hospitalId, tenantId],
      });
    },
  });
}
